import React, { Component } from 'react';

import BoxSize from '../../style/styledComponents/BoxSize';
import FormButton from '../../style/styledComponents/FormButton';
import FormField from '../../style/styledComponents/FormField';
import Icons from '../../style/styledComponents/Icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import vivo from '../../_redux/actions/api/vivoUser';
import { verifyPin } from '../../_redux/actions/vivoUser';

import Header from '../../Components/Header';
import NavBtn from '../../Components/NavBtn';
import LoadingB from '../../Components/LoadingBeneficiario';

import { setWaitCampaign } from '../../_redux/actions/campaign';
import InputMask from 'react-input-mask';

import VivoAuthImg from '../../img/vivoauth.svg';

import { FiAlertCircle } from 'react-icons/fi';
import { FaExclamation } from 'react-icons/fa';

import stores from '../../utils/stores';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import TitleSubscriber from '../../style/styledComponents/TitleSubscriber';

class VivoAuth extends Component {
	constructor(props) {
		super(props);

		this.state = {
			telefone: '',
			inputData: {
				phone: '',
				loja: null
			},
			hasError: false,
			hasError1: false,
			isComplete: false,
			errorOnField: {},
			title: '',
			error: '',
			loading: false,
			currentTime: 60,
			awaitTime: 0
		};

		this.setField = this.setField.bind(this);
		this.validateField = this.validateField.bind(this);
		this.clearErrorOnFocus = this.clearErrorOnFocus.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.sendCode = this.sendCode.bind(this);
		this.clearError = this.clearError.bind(this);
		this.isComplete = this.isComplete.bind(this);
		this.sendPinAgain = this.sendPinAgain.bind(this);
		this.sendToStart = this.sendToStart.bind(this);
	}

	async componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;
		}
		sessionStorage.setItem('store', stores.vivo);

		let { VivoUser } = this.props;

		if (VivoUser.data.length === 0) {
			this.props.history.push(process.env.PUBLIC_URL + `/vivoavulso/`);
		} else {
			let id = VivoUser.data.external_product_id.toString();
			let phone = VivoUser.data.phone;
			await vivo.sendPin(id, phone);

			this.timerID = setInterval(() => this.tick(), 1000);
		}
	}
	setField(e) {
		let value = e.target.value;
		let name = e.target.getAttribute('name');

		if (name === 'phone') {
			value = value
				.replace(/( )+/g, '')
				.replace(/_$/g, '')
				.replace('(', '')
				.replace(')', '')
				.replace('-', '');
			value = value;
		}
		let inputData = { ...this.state.inputData };
		inputData[name] = value;
		this.setState({
			inputData
		});

		this.handleIsComplete(value, 'phone');
	}
	clearErrorOnFocus(field) {
		this.setState({
			errorOnField: {
				...this.state.errorOnField,
				[field]: null
			}
		});
	}

	validateField(e, field) {
		const errorMsgs = {
			phone: 'PIN inválido'
		};
		let value = e.target.value;
		value = value
			.replace(/( )+/g, '')
			.replace(/_$/g, '')
			.replace('(', '')
			.replace(')', '')
			.replace('-', '');
		const isValid = this.checkField(field, value);
		if (isValid) {
			this.setState({
				errorOnField: { ...this.state.errorOnField, [field]: null },
				isComplete: true
			});
		} else {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					[field]: errorMsgs[field]
				}
			});
		}

		this.handleIsComplete(value, 'phone');

		//if (!this.state.hasMoreThanOneSub) {
		//}
	}
	handleIsComplete(e, field) {
		const isIncomplete = this.checkField(field, e);
		if (isIncomplete) {
			this.setState({
				isComplete: true
			});
		} else {
			this.setState({
				isComplete: false
			});
		}
	}

	checkField(name, value) {
		let isValidField = false;
		let checkField = {
			phone: /^([0-9]{4})$/
		};
		if (checkField[name].test(value)) {
			isValidField = true;
		} else isValidField = false;

		return isValidField;
	}

	sendCode() {
		//let loja = this.props.match.params;
		let { VivoUser } = this.props;
		let id = VivoUser.data.external_product_id.toString();
		let phone = VivoUser.data.phone;
		let loja = 'vivoavulso';
		let pin = this.state.inputData.phone;
		let data = { phone, pin, id };
		this.setState({
			loading: true
		});
		var result = this.props.verifyPin(data);

		result.then(valor => {
			if (valor === false) {
				//if (true) {
				this.setState({
					loading: false
				});
				this.props.history.push(
					process.env.PUBLIC_URL + `/${loja}/sucessoCliente`
				);
			} else {
				this.setState({
					hasError: true,
					loading: false,
					title: 'PIN inválido',
					error:
						'O PIN digitado é inválido. Se você recebeu mais do que um, use o último ou tente enviar mais um PIN.',
					button: 'TENTAR NOVAMENTE'
				});
			}
		});
	}
	clearError() {
		this.setState({
			hasError: null,
			hasError1: null
		});
	}
	isComplete() {
		if (this.state.inputData.phone.length < 12) {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					'phone': 'PIN inválido'
				}
			});
		} else {
		}
	}

	sendPinAgain() {
		let { VivoUser } = this.props;
		let id = VivoUser.data.external_product_id.toString();
		let phone = VivoUser.data.phone;
		var result = vivo.sendPin(id, phone);

		result.then(valor => {
			if (valor === false) {
				this.setState({
					hasError1: true,
					title: 'PIN Enviado',
					error:
						'Seu PIN foi reenviado com sucesso. Se tiver qualquer problema para recebê-lo entre em contato com a VIVO.',
					button: 'Entendi',
					awaitTime: true
				});
			} else {
				this.setState({
					hasError1: true,
					title: 'Ops',
					error:
						'Seu pin não foi reenviado. Tente mais tarde ou se tiver com problema para recebê-lo entre em contato com a VIVO.',
					button: 'Entendi',
					awaitTime: true
				});
			}
		});
	}

	tick() {
		this.setState((prevState, props) => ({
			currentTime: prevState.currentTime - 1
		}));
		if (this.state.currentTime === 0) {
			this.setState({ awaitTime: false, currentTime: 60 });
		}
	}
	sendToStart() {
		this.props.history.push(process.env.PUBLIC_URL + `/${'vivoavulso'}`);
	}
	render() {
		const { VivoUser } = this.props;
		let errorElm = null;
		let phoneFormatted = '';
		if (Object.keys(VivoUser.data).length > 0) {
			phoneFormatted =
				'(' +
				VivoUser.data.phone.substr(0, 2) +
				')' +
				' 9xxxx-xxx' +
				VivoUser.data.phone.substr(10);
		} else {
		}
		if (this.state.hasError) {
			errorElm = (
				<div className='overlay'>
					<FormButton className='overlay-box'>
						<BoxSize className='overlay-box--content-epay'>
							<div className='title-alert2'>
								<Icons className='icon-container2'>
									<FaExclamation color={'white'} size={16} />
								</Icons>
								<h2>{this.state.title}</h2>
							</div>
							<p>{this.state.error} </p>
						</BoxSize>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-ok-epay'
								onClick={this.clearError}>
								{this.state.button}
							</button>
						</div>
					</FormButton>
				</div>
			);
		} else if (this.state.hasError1) {
			errorElm = (
				<div className='overlay'>
					<div className='overlay-box'>
						<BoxSize className='overlay-box--content-epay'>
							<div className='title-alert2'>
								<small className='icon-container2'>
									<FaExclamation color={'white'} size={16} />
								</small>
								<h2>{this.state.title}</h2>
							</div>
							<p>{this.state.error} </p>
						</BoxSize>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-ok-epay'
								onClick={this.clearError}>
								{this.state.button}
							</button>
						</div>
					</div>
				</div>
			);
		}
		const pathArray = window.location.pathname.split('/');
		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<div className='page-wrapper'>
					<div className=' footer-adjustment'>
						{errorElm}
						<Header {...this.props} />
						<BoxSize className=''>
							<div className='content-vivo'>
								<TitleSubscriber className='visible-xs visible-sm'>
									<h2>Você recebeu um PIN no seu celular!</h2>

									<p>
										Verifique se recebeu um PIN (código de 4 dígitos) por SMS no
										seu celular
									</p>
								</TitleSubscriber>
								<TitleSubscriber className='row visible-md visible-lg'>
									<h2>Você recebeu um PIN no seu celular!</h2>

									<p>
										Verifique se recebeu um PIN (código de 4 dígitos) por SMS no
										seu celular
									</p>
								</TitleSubscriber>
							</div>
						</BoxSize>
						<BoxSize className=''>
							<div className='box-content-width'>
								<img
									className='row visible-md visible-lg'
									style={{ width: 200, marginTop: 10 }}
									src={VivoAuthImg}
									alt=''/>
								<img
									className='row visible-xs visible-sm'
									style={{ width: 150, marginTop: 10 }}
									src={VivoAuthImg}
									alt=''/>

								<FormField className='box-number'>
									<span>Enviando para:</span>

									<div className='box-tel'>
										<h3>{phoneFormatted}</h3>
										<a onClick={this.sendToStart}>Editar telefone</a>{' '}
									</div>

									<div className='form-group2 form-group3 form-number-phone'>
										<InputMask
											type='text'
											className='form-control2'
											id='telefone'
											required
											name='phone'
											onChange={this.setField}
											onBlur={e => this.validateField(e, 'phone')}
											onFocus={() => this.clearErrorOnFocus('phone')}
											mask='9999'
											value={this.state.inputData.phone}
										/>

										<label htmlFor='telefone'>Digite o PIN recebido</label>
										{this.state.errorOnField.phone && (
											<div className='error-msg'>
												<FiAlertCircle size={13} color={'red'} />
												<small className='credit-card-error'>
													{this.state.errorOnField.phone || 'PIN inválido'}
												</small>
											</div>
										)}
									</div>
								</FormField>
								{!this.state.isComplete ? (
									<NavBtn
										disabled={!this.state.isComplete}
										goForward={this.isComplete}
										goForwardText={'AUTENTICAR'}
										step={true}></NavBtn>
								) : this.state.loading ? (
									<div className='loading-beneficiario2'>
										<LoadingB type='spin' color='gray' size={25} />
										<span>Carregando...</span>
									</div>
								) : (
									<NavBtn
										disabled={this.state.isLoading}
										goForward={this.sendCode}
										goForwardText={'AUTENTICAR'}></NavBtn>
								)}
								{this.state.awaitTime ? (
									<>
										<p style={{ fontSize: 14 }}>
											{' '}
											Enviar novamente em {this.state.currentTime} segundos
										</p>
										<a style={{ color: 'grey', fontSize: 14 }}>
											Não recebeu? Enviar novo PIN
										</a>
									</>
								) : (
									<a onClick={this.sendPinAgain}>
										Não recebeu? Enviar novo PIN
									</a>
								)}
							</div>
						</BoxSize>
					</div>
					<div className='container-fluid'></div>
				</div>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign, verifyPin }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VivoAuth);
